export const css = {
	root: '_2SX8M1X5',
	' _key': 'ascm-theme/ascm/backview/backview'
};

export default css;
